
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useState } from "react";
import { AvatarUploadDialog } from "./AvatarUploadDialog";

interface AccountHeaderProps {
  user: {
    name: string;
    avatar: string;
    subscription: string;
    memberSince: string;
    id?: string;
  };
}

const getSubscriptionBadge = (subscription: string) => {
  switch (subscription) {
    case "enterprise":
      return <Badge className="bg-ai-indigo">Enterprise</Badge>;
    case "pro":
      return <Badge className="bg-premium">Pro</Badge>;
    case "basic":
      return <Badge variant="outline" className="text-gray-500">Basic</Badge>;
    default:
      return <Badge variant="outline">{subscription}</Badge>;
  }
};

export const AccountHeader = ({ user }: AccountHeaderProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
        <div className="flex items-center">
          <div onClick={() => setIsDialogOpen(true)} className="cursor-pointer group relative">
            <Avatar className="h-16 w-16 mr-4">
              <AvatarImage src={user.avatar} alt={user.name} />
              <AvatarFallback className="bg-ai-indigo text-white text-xl">
                {user.name.split(' ').map(n => n[0]).join('')}
              </AvatarFallback>
            </Avatar>
            <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded-full">
              <span className="text-white text-xs">Change</span>
            </div>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{user.name}</h1>
            <div className="flex items-center mt-1">
              <p className="text-gray-500 mr-2">Member since {user.memberSince}</p>
              {getSubscriptionBadge(user.subscription)}
            </div>
          </div>
        </div>
      </div>

      <AvatarUploadDialog 
        isOpen={isDialogOpen} 
        onClose={() => setIsDialogOpen(false)}
        userId={user.id || ""}
        currentAvatar={user.avatar}
      />
    </>
  );
};
